<template>
  <div class="home">
    <div class="head">
      <my-header />
    </div>
    <div class="main">
      <router-view></router-view>
      <el-button v-show="isShowTop" class="topBtn" @click="goTop"></el-button>
    </div>
    <div class="footer">
      <my-footer />
    </div>
  </div>
</template>

<script>
import MyHeader from "@/components/Header.vue";
import MyFooter from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    MyHeader,
    MyFooter,
  },
  data() {
    return {
      isShowTop: false,
    };
  },
  methods: {
    scrollHander() {
      this.isShowTop = window.scrollY > 0;
    },
    goTop() {
      var si = setInterval(() => {
        var sy = window.scrollY - 100;
        window.scrollTo(0, sy);
        if (window.scrollY < 1) {
          clearInterval(si);
        }
      }, 10);

      this.isShowTop = false;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHander);
  },
};
</script>

<style lang="scss">
.home {
  .main {
    width: 100%;
    min-height: 60vh;
    .topBtn {
      position: fixed;
      width: 3rem;
      height: 3rem;
      bottom: 4rem;
      right: 2rem;
      padding: 0;
      z-index: 100;
      border: none;
      box-shadow: 0px 2px 20px 0px rgba(3, 3, 3, 0.2);
      background: url("../assets/img/goTop1.png") no-repeat center;
      background-size: 3rem 3rem;
    }
    .topBtn:hover {
      background: url("../assets/img/goTop2.png") no-repeat center;
      background-size: 3rem 3rem;
    }
  }
  .el-button{
    padding: 0;
  }
}
</style>
